import React, { useState } from "react";
import EntityHeader from "./common/EntityHeader";
import Card from "react-bootstrap/Card";
import FieldDisplay from "./common/FieldDisplay";
import {
  getFieldDate,
  getFieldName,
  getFieldText,
} from "../scripts/helperScripts";
import BedSearchModal from "./common/BedSearchModal";
import FosterHomeBedModal from "./common/FosterHomeBedModal";

function FosterHomeBedEntity({
  clientId,
  clientProgram,
  beds,
  showExpired,
  updateBeds,
  ...rest
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [isFosterBedOpen, setIsFosterBedOpen] = useState(false);
  const [fosterHomeBedData, setFosterHomeBedData] = useState({});
  const [fosterHome, setFosterHome] = useState({});

  const hideModal = () => {
    setIsOpen(false);
  };

  const hideFosterBedModal = () => {
    setIsFosterBedOpen(false);
  };

  const showFosterBedModal = (bed) => {
    const home = {
      ccx_name: getFieldName(bed.ccx_fostercarehome),
      ccx_fostercarehomeid: getFieldText(bed.ccx_fostercarehome),
    };

    setFosterHomeBedData(bed);
    setFosterHome(home);

    setIsFosterBedOpen(true);
  };

  const addNew = () => {
    setIsOpen(true);
  };

  const filterBeds = () => {
    if (getFieldName(clientProgram["unit.ccx_programtype"]) === "TFC")
      return beds.filter((bed) =>
        getFieldName(bed.ccx_clientprogram).includes(
          clientProgram.ccx_name.split("-")[0]
        )
      );
    else return [];
  };

  return (
    <>
      {isOpen ? (
        <BedSearchModal
          isOpen={isOpen}
          hideModal={hideModal}
          clientId={clientId}
          clientProgram={clientProgram}
          updateBeds={updateBeds}
        ></BedSearchModal>
      ) : null}
      {isFosterBedOpen ? (
        <FosterHomeBedModal
          isOpen={isFosterBedOpen}
          hideModal={hideFosterBedModal}
          fosterHome={fosterHome}
          initialData={fosterHomeBedData}
          updateBeds={updateBeds}
        ></FosterHomeBedModal>
      ) : null}
      <EntityHeader
        {...rest}
        title="Foster Home Beds"
        add={addNew}
        clientId={clientId}
        body={filterBeds().map((bed) => (
          <div
            key={bed.ccx_fosterchildid}
            className={
              bed.ccx_actualdischarge !== undefined && !showExpired
                ? "d-none p-2"
                : "d-block p-2"
            }
          >
            <Card className="card-safy">
              <Card.Header
                className="p-0 ps-2 bg-safy1-1"
                style={{ color: "white" }}
              >
                <div className="row">
                  <div className="col-10 ps-4 pt-1">{bed.ccx_name}</div>
                  <div className="col-2">
                    <i
                      className="fas fa-pen float-end p-2"
                      onClick={() => {
                        showFosterBedModal(bed);
                      }}
                    ></i>
                  </div>
                </div>
              </Card.Header>
              <Card.Body
                className={
                  bed.ccx_actualdischarge === undefined
                    ? "p-2 card-body-safy"
                    : "p-2 bg-warning"
                }
              >
                <FieldDisplay
                  label="Service Item:"
                  value={getFieldName(bed.ccx_serviceitem)}
                />
                <FieldDisplay
                  label="Service Status:"
                  value={getFieldName(bed.ccx_servicestatuslookup)}
                />
                <FieldDisplay
                  label="Actual Admission:"
                  value={getFieldDate(bed.ccx_actualadmission)}
                />
                {bed.ccx_actualdischarge && (
                  <FieldDisplay
                    label="Actual Discharge: "
                    value={getFieldDate(bed.ccx_actualdischarge)}
                  />
                )}
              </Card.Body>
            </Card>
          </div>
        ))}
      />
    </>
  );
}

export default FosterHomeBedEntity;
